import axiosInstance from "../../../axios";
import React, { useState, useEffect } from "react";
import { Loading } from "../../Other/Loading";

const Forms = ({ setModal, title, editData = {} }) => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(editData.image || "");
  const [videoPreview, setVideoPreview] = useState(editData.video || "");
  const [oldCompanyLogoPreview, setOldCompanyLogoPreview] = useState(editData.oldCompanyLogo || "");
  const [newCompanyLogoPreview, setNewCompanyLogoPreview] = useState(editData.newCompanyLogo || "");

  const [formValue, setFormValue] = useState({
    name: editData.name || "",
    quote: editData.quote || "",
    description: editData.description || "",
    oldJob: editData.oldJob || "",
    // oldCompany: editData.oldCompany || "",
    newJob: editData.newJob || "",
    // newCompany: editData.newCompany || "",
    // rating: editData.rating || "",
    // graduationRate: editData.graduationRate || "",
    salaryHike: editData.salaryHike || "",
    oldCompanyLogo: null,
    newCompanyLogo: null,
    image: null,
    video: null,
  });

  useEffect(() => {
    return () => {
      if (imagePreview) URL.revokeObjectURL(imagePreview);
      if (videoPreview) URL.revokeObjectURL(videoPreview);
      if (oldCompanyLogoPreview) URL.revokeObjectURL(oldCompanyLogoPreview);
      if (newCompanyLogoPreview) URL.revokeObjectURL(newCompanyLogoPreview);
    };
  }, [imagePreview, videoPreview, oldCompanyLogoPreview, newCompanyLogoPreview]);

  const handleChange = (event) => {
    const { name, value, type, files } = event.target;
    if (type === "file" && files.length > 0) {
      const file = files[0];
      const fileURL = URL.createObjectURL(file);

      if (name === "image") setImagePreview(fileURL);
      if (name === "video") setVideoPreview(fileURL);
      if (name === "oldCompanyLogo") setOldCompanyLogoPreview(fileURL);
      if (name === "newCompanyLogo") setNewCompanyLogoPreview(fileURL);

      setFormValue((prev) => ({ ...prev, [name]: file }));
    } else {
      setFormValue((prev) => ({ ...prev, [name]: value }));
    }
  };
  const validate = () => {
    const errorObj = {};
    [
      "name",
      "quote",
      "description",
      "oldJob",
      // "oldCompany",
      "newJob",
      // "newCompany",
      // "rating",
      // "graduationRate",
      "salaryHike",
    ].forEach((field) => {
      if (!formValue[field]) errorObj[field] = ` Please enter a valid ${field.replace(/([A-Z])/g, " $1").trim()}`;
    });
    setErrors(errorObj);
    return Object.keys(errorObj).length === 0;
  };


  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    setErrors({});

    const formData = new FormData();
    Object.keys(formValue).forEach((key) => {
      if (formValue[key]) formData.append(key, formValue[key]);
    });

    try {
      if (editData?.id) {
        await axiosInstance.put(`/job-transitions/${editData.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await axiosInstance.post("/job-transitions", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      setSuccessMessage(`${title} has been successfully ${editData?.id ? "updated" : "added"}`);
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forms-width-55 add-page !bg-dark">
      <div className="dashboard-container-new padding-custom-dashboard-0">
        <p>{editData?.id ? `Edit ${title}` : `Add New ${title}`}</p>
      </div>
      {successMessage ? (
        <>
          <div className="success-message text-bold">{successMessage}</div>
          <div className="margin-top-new-01-0">
            <button className="lastmonth-btn-0" onClick={() => setModal()}>
              Close
            </button>
          </div>
        </>
      ) : (
        <div className="form-content">
          {Object.entries(formValue).map(([field, value]) => (
            field !== "image" && field !== "video" && field !== "oldCompanyLogo" && field !== "newCompanyLogo" && (
              <div className="form-group" key={field}>
                <label>{field.replace(/([A-Z])/g, " $1").trim()}*</label>
                <input
                  type="text"
                  name={field}
                  value={value}
                  onChange={handleChange}
                />
                {errors[field] && <span className="error-text">{errors[field]}</span>}
              </div>
            )
          ))}

          {/* Image Preview */}
          <div className="form-group">
            <label>Image File</label>
            <input type="file" name="image" accept="image/*" onChange={handleChange} />
            {imagePreview && <img src={imagePreview} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover" }} className="preview-image" />}
          </div>

          {/* Video Preview */}
          <div className="form-group">
            <label>Video File</label>
            <input type="file" name="video" accept="video/*" onChange={handleChange} />
            {videoPreview && <video src={videoPreview} controls style={{ width: "100px", height: "100px", objectFit: "cover" }} className="preview-video" />}
          </div>

          {/* Old Company Logo Preview */}
          <div className="form-group">
            <label>Old Company Logo</label>
            <input type="file" name="oldCompanyLogo" accept="image/*" onChange={handleChange} />
            {oldCompanyLogoPreview && <img src={oldCompanyLogoPreview} style={{ width: "100px", height: "100px", objectFit: "cover" }} alt="Old Company Logo" className="preview-logo" />}
          </div>

          {/* New Company Logo Preview */}
          <div className="form-group">
            <label>New Company Logo</label>
            <input type="file" name="newCompanyLogo" accept="image/*" onChange={handleChange} />
            {newCompanyLogoPreview && <img src={newCompanyLogoPreview} alt="New Company Logo" style={{ width: "100px", height: "100px", objectFit: "cover" }} className="preview-logo" />}
          </div>
          {loading ? <Loading /> : null}
          <div className="dashboard-main justify-flex-new">
            <div className="margin-top-new-01-0">
              <button className="export-btn" onClick={handleSubmit} disabled={loading}>
                {editData?.id ? "Update" : "Submit"}
              </button>
            </div>
            <div className="margin-top-new-01-0">
              <button className="lastmonth-btn-0" onClick={() => setModal()}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Forms;
